import React, { useEffect } from "react";
import "../../assets/css/style.css";
import Image from "../../assets/Image";
import WOW from "wowjs";
import Testimonialnew from "../testimonialnew";

const All_Services = () => {
  useEffect(() => {
    new WOW.WOW().init();
  });

  return (
    <>
      <section className="appservices-section d-flex">
        <div className="appservices-body">
          <div className="appservices-text">
            <h1>Services</h1>
            <p><span>Our Services</span></p>
          </div>
        </div>
      </section>

      <section className="industrial-work app-development-service">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 offset-lg-3">
              <div className="industrial-body">
                <h2 className="all-title text-center">
                  Software And Services That Solve Your Problems
                </h2>
              </div>
            </div>

            <div className="col-lg-12">
              <div>
                <img
                  className="img-responsive desktopservice-banner"
                  src={Image.servicebanner}
                  alt="service banner"
                />
                <img
                  className="img-responsive service-mobbanner"
                  src={Image.ServicesBannerImg}
                  alt="service banner"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-us app-development-process">
        <div className="container">
          <div className="services-icons">
            <div className="row">
              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceDesigning} alt="" />
                  </div>
                  <h5>App Development</h5>
                  <div className="text">
                    <p>
                      Understanding what you want out of your application and how do you plan to implement it.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/services" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceDevelopment} alt="" />
                  </div>
                  <h5>Web Development</h5>
                  <div className="text">
                    <p>
                      We build modern, user-friendly websites that work smoothly on all devices—customized to fit your business from design to launch.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/webDevelopment" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceTesting} alt="" />
                  </div>
                  <h5>API Integration</h5>
                  <div className="text">
                    <p>
                      We integrate APIs to streamline workflows, automate tasks, and boost efficiency. Whether third-party or custom, we ensure smooth and secure connections.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/payment" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceLaunching} alt="" />
                  </div>
                  <h5>Website Optimization</h5>
                  <div className="text">
                    <p>
                      We optimize your website for speed, performance, and SEO to deliver a faster, smoother user experience.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/websiteoptimization" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceMaintainance} alt="" />
                  </div>
                  <h5>IT Solution</h5>
                  <div className="text">
                    <p>
                      We provide reliable IT solutions tailored to support your business operations and growth. Let us handle the tech, so you can focus on what matters most.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/itsolution" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.serviceMaintainance} alt="" />
                  </div>
                  <h5>QA Testing</h5>
                  <div className="text">
                    <p>
                      We test your software to ensure it’s reliable, secure, and bug-free. From functionality to performance, our QA process covers it all. Deliver quality with confidence.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/qatesting" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 service-block-one service-block-one-tall offset-md-4">
                <div className="inner-box">
                  <div className="icon">
                    <img src={Image.aiMlService} alt="AI & Machine Learning" />
                  </div>
                  <h5>AI & Machine Learning</h5>
                  <div className="text">
                    <p>
                      Empower your business with intelligent AI solutions that automate processes, uncover insights, and enhance customer experiences. We build custom AI and ML applications tailored to your business goals.
                    </p>
                  </div>
                  <div className="link-btn">
                    <a href="/aimachinelearning" className="theme-btn btn-style-one style-two">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Testimonialnew from={"allservice"} />
    </>
  );
};

export default All_Services;
